'use es6';

export var isAfterHalloween = function isAfterHalloween() {
  var now = new Date();
  var halloweenEndTime = new Date('November 1, 2021 01:00:00');
  return now.getTime() > halloweenEndTime.getTime();
};

var inIframe = function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export var isThemingEnabled = function isThemingEnabled() {
  return window.I18N_MANUAL_LANG === 'en' && !inIframe() && !isAfterHalloween();
};